<foo-control-label [control]="control" [templateOptions]="templateOptions"></foo-control-label>

<framework-uploader
                    [formControl]="control"
                    [extensions]="'png, JPG, PDF'"
                    [fileType]="'image'"
                    [multiple]="multiple"
></framework-uploader>

